import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalVariableProvider } from "./Context/GlobalContext";
import { useAuthContext, useAuthActionsContext } from "./Context/AuthContext";
import { useLanguageActionContext } from "./Context/LanguageContext";
import Login_new from "./Components/Access-Control/Login2";
import access_controlStores from "./Stores/Access_ControlStores";
import access_controlConstants from "./Constants/Access_ControlConstants";
import GlobalSpinner from "./Components/Spinner/GlobalSpinner";
import { AuthContextProvider } from "./Context/AuthContext";
import { MessageContextProvider } from "./Context/SuccessErrorMessageContext";
import { AlertMessageContextProvider } from "./Context/AlertMessageContext";
import {
  useThemeActionsContext,
  useSubDomainActionsContext,
} from "./Context/ThemeContext";
import { useThemeContext } from "./Context/ThemeContext";
import Branding from "./Components/Branding/Branding";
import { IsSubDomain } from "./helpers/isSubDomain";
import UserManagementActions from "./Actions/UserManagementActions";
import usermanagementStore from "./Stores/UsermanagementStore";
import usermanagementConstants from "./Constants/UsermanagementConstants";
import { useGlobalSpinnerActionsContext } from "./Context/GlobalSpinnerContext";
import { SelectedFilterChangeProvider } from "./Context/GridEquipListContext";
// import { useAuthContext } from "./Context/AuthContext";
import RouteConfig from "./Components/PrivateRoute/RoteConfig";

import Access_ControlConstants from "./Constants/Access_ControlConstants";
import access_ControlStore from "./Stores/Access_ControlStores";

import { useLanguageContext } from "./Context/LanguageContext";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LangauageVerifier from "./Components/LangauageVerifier";
import Access_ControlActions from "./Actions/Access_ControlActions";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TourGuide from "./helpers/TourGuide/tourGuide";
import { TourGuidProvider } from "./Context/TourGuidContext";
import TourGuideWrapper from "./helpers/TourGuide/TourGuideWrapper";
import { LoggedInUserInfoProvider } from "./Context/LoggedInUserInfoContext";

function App(props) {
  const themeValue = createTheme({
    // components: {
    //   MuiStepLabel: {
    //     styleOverrides: {
    //       label: {
    //         fontSize: "1.5rem",
    //       },
    //     },
    //   },
    // },
  });

  const UpdateLogged = useAuthActionsContext();
  const isAuthenticated = useAuthContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const isAuthenticatedRef = useRef(isAuthenticated);
  const updateTheme = useThemeActionsContext();
  const theme = useThemeContext();
  const updateSubDomain = useSubDomainActionsContext();
  const organDetailRef = useRef("");
  const [domainStatus, setDomainStatus] = useState({
    isSubDomin: false,
    subDomain: "",
  });
  const [isValidSubDomin, setIsValidSubDomin] = useState(false);
  const UpdateLanguage = useLanguageActionContext();

  const orgNeedBranding = useRef(true);

  const getorganisationDetails = (IsLogin) => {
    const { isSubDomin, subDomain } = IsSubDomain();
    if (!(isAuthenticatedRef.current.isAuthenticated && IsLogin)) {
      if (subDomain !== "") {
        setIsValidSubDomin(false);
        setGlobalSpinner(true);
        let _params =
          window.location.search === ""
            ? ""
            : window.location.search.split("?");
        UserManagementActions.getOrganConfig(
          _params === "" ? subDomain : _params[1],
        );
      } else {
        Access_ControlActions.GetLocalizationMessages(
          sessionStorage.getItem("APP-LANGUAGE")
            ? sessionStorage.getItem("APP-LANGUAGE")
            : window.navigator.language.substring(0, 2),
        );
        setIsValidSubDomin(true);
      }
    } else {
      setDomainStatus({ isSubDomin: isSubDomin, subDomain: subDomain });
      updateTheme(sessionStorage.getItem("theme"));
      setIsValidSubDomin(true);
    }
  };
  const orgDetailsWithoutBranding = () => {
    setGlobalSpinner(true);
    UserManagementActions.getOrganConfig("daimlertruck");
  };

  useEffect(() => {
    if (!orgNeedBranding.current) {
      orgDetailsWithoutBranding();
    } else {
      if (window.location.host)
        getorganisationDetails(isAuthenticatedRef.current.isAuthenticated);
    }
  }, [isAuthenticatedRef.current]);

  useEffect(() => {
    function getOrgConfigSuccess() {
      setDomainStatus({ isSubDomin: true, subDomain: "" });
      setIsValidSubDomin(true);
      var res = usermanagementStore.getOrgConfig();
      if (res) {
        organDetailRef.current = res;
        sessionStorage.setItem("subDomain", res.subDomain);
        sessionStorage.setItem("theme", "default-theme");
        sessionStorage.setItem("df", res.dateFormat);
        updateTheme("default-theme");
        UpdateLanguage(
          sessionStorage.getItem("APP-LANGUAGE")
            ? sessionStorage.getItem("APP-LANGUAGE")
            : res.language,
        );
        updateSubDomain(res.subDomain);
      }
      setGlobalSpinner(false);
    }
    const getOrgConfigFailure = () => {
      const redirectURL = window.location.host.replace(
        window.location.host.split(".")[0] + ".",
        "",
      );
      window.open(window.location.protocol + "//" + redirectURL + "/", "_self");
    };

    usermanagementStore.addChangeListener(
      usermanagementConstants.GET_ORG_CONFIG_SUCCESS,
      getOrgConfigSuccess,
    );

    usermanagementStore.addChangeListener(
      usermanagementConstants.GET_ORG_CONFIG_FAILURE,
      getOrgConfigFailure,
    );
    return () => {
      usermanagementStore.removeChangeListener(
        usermanagementConstants.GET_ORG_CONFIG_SUCCESS,
        getOrgConfigSuccess,
      );

      usermanagementStore.removeChangeListener(
        usermanagementConstants.GET_ORG_CONFIG_FAILURE,
        getOrgConfigFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (theme !== "") {
      document.body.className = `breakpoint-lg overflow-hidden ${theme}`;
    }
  }, [theme]);

  const handleSessionExpired = () => {
    if (!orgNeedBranding.current) {
      orgDetailsWithoutBranding();
    } else {
      if (organDetailRef.current === "") {
        getorganisationDetails(false);
      }
    }
  };

  useEffect(() => {
    const redirectToLogin = () => {
      UpdateLogged(false);
      handleSessionExpired();
    };

    access_ControlStore.addChangeListener(
      Access_ControlConstants.SESSION_EXPIRED,
      redirectToLogin,
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.SESSION_EXPIRED,
        redirectToLogin,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      if (!orgNeedBranding.current) {
        orgDetailsWithoutBranding();
      } else {
        if (organDetailRef.current === "") {
          getorganisationDetails(false);
        }
      }
    }

    access_controlStores.addChangeListener(
      access_controlConstants.LOGOUT_SUCCESS,
      updateData,
    );

    return () => {
      access_controlStores.removeChangeListener(
        access_controlConstants.LOGOUT_SUCCESS,
        updateData,
      );
    };
  }, []);

  return (
    <div className="wrapper bgWhite">
      <ThemeProvider theme={themeValue}>
        <GlobalVariableProvider>
          <GlobalSpinner />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            style={{ zIndex: 99999 }}
          />
          <MessageContextProvider>
            <AlertMessageContextProvider>
              <SelectedFilterChangeProvider>
                <LangauageVerifier>
                  <TourGuidProvider>
                    <TourGuideWrapper />
                    {/* <TourGuide /> */}
                    <LoggedInUserInfoProvider>
                      <Routes>
                        {orgNeedBranding && isValidSubDomin && (
                          <Route
                            path="/"
                            element={
                              domainStatus.isSubDomin ? (
                                <Login_new
                                  orgDetails={organDetailRef.current}
                                />
                              ) : (
                                <Branding />
                              )
                            }
                          />
                        )}
                        {RouteConfig()}
                      </Routes>
                    </LoggedInUserInfoProvider>
                  </TourGuidProvider>
                </LangauageVerifier>
              </SelectedFilterChangeProvider>
            </AlertMessageContextProvider>
          </MessageContextProvider>
        </GlobalVariableProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
